// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"_2Zh_5SnNJPs1eBDsxLM3WQ","titleWrapper":"_2ofubbpuA-T2EyRIcevqcR","title":"_2gLqswMaiOFNj7jdMfLuBH"};